const nodeText = (node: any): string =>
  node?.type === 'text' ? node.text || '' : (node?.content || []).map(nodeText).join('');

/**
 * The paragraph in the cell after the "Report Status:" label of a report document (TipTap
 * JSON), found by label. A fixed path into the document wrote the status into whichever
 * cell sat there, which in the current header is Heart rate.
 */
export function findReportStatusParagraph(node: any): any {
  if (!node || typeof node !== 'object') return null;
  if (node.type === 'tableRow' && Array.isArray(node.content)) {
    const idx = node.content.findIndex(cell => /^report status:?$/i.test(nodeText(cell).trim()));
    if (idx >= 0) {
      return node.content[idx + 1]?.content?.find(child => child?.type === 'paragraph') ?? null;
    }
  }
  for (const child of node.content || []) {
    const found = findReportStatusParagraph(child);
    if (found) return found;
  }
  return null;
}

/** Write `status` into the report's status cell. Returns false when there is no such cell. */
export function setReportStatusCell(doc: any, status: string): boolean {
  const paragraph = findReportStatusParagraph(doc);
  if (!paragraph || !status) return false;
  paragraph.content = [{ type: 'text', text: status }];
  return true;
}
